/**
 * Constants for the New Trader Dashboard feature
 */

/**
 * Path where the new trader dashboard (and Training Camp section) is rendered.
 * Use this for the Training Camp nav link so the sidebar and dashboard stay in sync.
 * Same route as APP_DEFAULT_PATH in ~/config.
 */
export const NEW_TRADER_DASHBOARD_PATH = '/dashboard/default';

/** Fragment id for the Training Camp section (for deep links: .../dashboard/default#training-camp). */
export const TRAINING_CAMP_SECTION_ID = 'training-camp';

/**
 * Training Camp app URL by environment.
 */
export const TRAINING_CAMP_URL_BY_ENVIRO: Record<string, string> = {
  dev: 'https://training-camp.dev.topstep.com/',
  staging: 'https://training-camp.stage.topstep.com/',
  production: 'https://training-camp.topstep.com/',
  prod: 'https://training-camp.topstep.com/',
};

/**
 * Training Camp URL for nav (and any other links).
 */
export function getTrainingCampNavUrl(): string {
  const enviro = typeof process !== 'undefined' ? process.env?.ENVIRO : undefined;
  if (typeof enviro === 'string' && enviro in TRAINING_CAMP_URL_BY_ENVIRO) {
    return TRAINING_CAMP_URL_BY_ENVIRO[enviro];
  }
  return TRAINING_CAMP_URL_BY_ENVIRO.dev;
}

/** Resolved Training Camp URL for nav link. */
export const TRAINING_CAMP_NAV_URL: string =
  process.env.TRAINING_CAMP_URL || getTrainingCampNavUrl();

/**
 * External resource URLs
 */
export const DEFAULT_TOPSTEP_TV_URL = 'https://www.youtube.com/@TopstepOfficial/streams';
export const DISCORD_INVITE_URL = 'https://discord.com/invite/topstep';

/**
 * TopstepTV Live Status Polling Configuration
 *
 * 5-minute interval for responsive updates. Backend schedule gating and caching
 * help manage YouTube API quota (10,000 units/day, 100 units per search request).
 * Monitor actual usage and adjust interval if approaching quota limits.
 *
 * IMPORTANT: Keep this value aligned with CACHE_TTL_MS in crystal/src/plugins/youtubeStatusPlugin.ts
 * to ensure frontend polling and backend caching stay synchronized.
 */

/** Poll interval for checking TopstepTV live status (5 minutes, aligned with backend cache TTL) */
export const TOPSTEP_TV_POLL_INTERVAL_MS = 300_000;
